// This file contains all the static data for the website.
// Real data from RG Servicio Técnico website

export const workImages = [
  {
    id: 1,
    title: "Trabajo realizado - Actualización",
    description: "Reparación de inicio y actualización de sistema",
    image: "/assets/38C6CB30-1D06-4B9D-B397-3AC7283259ED.jpg"
  },
  {
    id: 2,
    title: "Trabajo realizado - Limpieza profunda PC",
    description: "Limpieza detallada de componentes",
    image: "/assets/IMG_0114.jpg"
  },
  {
    id: 3,
    title: "Trabajo realizado - Limpieza profunda PC",
    description: "Mantenimiento interno completo",
    image: "/assets/IMG_0165.jpg"
  },
  {
    id: 4,
    title: "Trabajo realizado - Armado PC Gamer",
    description: "Armado completo PC Gamer",
    image: "/assets/IMG_0174.jpg"
  },
  {
    id: 5,
    title: "Trabajo realizado - Mantenimiento y limpieza Joystick PS4",
    description: "Reparación de gatillos y limpieza",
    image: "/assets/IMG_0242.jpg"
  },
  {
    id: 6,
    title: "Trabajo realizado - Optimización de sistema",
    description: "Optimización de Windows",
    image: "/assets/IMG_0287.jpg"
  },
  {
    id: 7,
    title: "Trabajo realizado - Limpieza profunda PC",
    description: "Limpieza detallada de componentes",
    image: "/assets/IMG_1645.jpg"
  },
  {
    id: 8,
    title: "Trabajo realizado - Limpieza profunda Notebook",
    description: "Limpieza detallada de componentes, cambio de pasta térmica",
    image: "/assets/IMG_2263.jpg"
  },
  {
    id: 9,
    title: "Trabajo realizado - Upgrade",
    description: "Actualización de componentes y BIOS",
    image: "/assets/IMG_2579.jpg"
  },
  {
    id: 10,
    title: "Trabajo realizado - Armado PC",
    description: "Armado PC",
    image: "/assets/IMG_3529.jpg"
  },
  {
    id: 11,
    title: "Trabajo realizado - Limpieza profunda PC",
    description: "Limpieza detallada de componentes",
    image: "/assets/IMG_3539.jpg"
  },
  {
    id: 12,
    title: "Trabajo realizado - Mantenimiento y limpieza Joystick PS4",
    description: "Reparación de botones y gatillos, limpieza",
    image: "/assets/IMG_3632.jpg"
  },
  {
    id: 13,
    title: "Trabajo realizado - Upgrade/Limpieza Notebook",
    description: "Actualización de SSD y limpieza de componentes",
    image: "/assets/IMG_3984.jpg"
  }
];

export const services = [
  {
    id: 1,
    title: "Mantenimiento PC/Notebook",
    price: "Desde: $32.000",
    description: "Revisión completa, limpieza detallada de componentes y cambio de pasta térmica.",
    icon: "settings",
    features: [
      "Limpieza interna + cambio de pasta térmica",
      "Optimización de Windows",
      "Actualización/Cambio de componentes",
      "Armado PC",
      "Backup de datos"
    ]
  },
  {
    id: 2,
    title: "Visita a Domicilio",
    price: "Desde: $32.000",
    description: "Vamos a tu casa a resolver cualquier problema que tengas con tus equipos.",
    icon: "home",
    features: [
      "Diagnóstico en el lugar",
      "Reparaciones menores",
      "Configuración de redes",
      "Asesoramiento personalizado"
    ]
  },
  {
    id: 3,
    title: "Asistencia Remota",
    price: "Desde: $19.000",
    description: "Solucionamos problemas de software y configuración de forma remota, sin que te muevas de tu casa.",
    icon: "wifi",
    features: [
      "Soporte para Windows/Office",
      "Soporte para impresoras y apps",
      "Configuración rápida",
      "Franjas de 30 a 60 min."
    ]
  },
  {
    id: 4,
    title: "Servicio Técnico de Celulares",
    price: "Desde: $22.000",
    description: "Cambio de módulo, batería, pin de carga y lector de huella. Trabajamos con todas las marcas.",
    icon: "smartphone",
    features: [
      "Cambio de pantalla",
      "Reparación de batería",
      "Pin de carga",
      "Lector de huella"
    ]
  },
  {
    id: 5,
    title: "Servicio Técnico de Impresoras",
    price: "Desde: $16.800",
    description: "Mantenimiento y reparación, cambio y reseteo de almohadillas, y cambio de componentes.",
    icon: "printer",
    features: [
      "Mantenimiento preventivo",
      "Reseteo de contadores",
      "Limpieza de cabezales",
      "Cambio de componentes"
    ]
  },
  {
    id: 6,
    title: "Servicio Técnico de Consolas",
    price: "Desde: $28.000",
    description: "Limpieza completa, cambio de pasta térmica y mantenimiento de coolers para PlayStation y Xbox.",
    icon: "joystick",
    features: [
      "Limpieza completa + cambio de pasta térmica",
      "Reparación de joysticks",
      "Actualización/Cambio de componentes"
    ]
  }
];

export const packs = [
  {
    id: 1,
    title: "Windows limpio + Office",
    price: "Desde: $69.000",
    icon: "laptop",
    features: [
      "Formateo/instalación limpia",
      "Drivers + Windows Update",
      "Optimización",
      "Instalación y configuración de Office"
    ]
  },
  {
    id: 2,
    title: "Upgrade SSD/RAM + Clonado",
    price: "Desde: $100.000",
    icon: "rocket",
    features: [
      "Hasta 2 cambios menores (RAM/SSD/HDD/FAN)",
      "Clonado de disco sin errores",
      "Verificación de arranque"
    ]
  },
  {
    id: 3,
    title: "Puesta a Punto (PC/Notebook)",
    price: "Desde: $61.000",
    icon: "settings",
    features: [
      "Limpieza interna + cambio de pasta térmica",
      "Optimización de Windows",
      "Chequeo S.M.A.R.T. y temperaturas"
    ]
  },
  {
    id: 4,
    title: "Consolas (PS/Xbox)",
    price: "Desde: $79.000",
    icon: "joystick",
    features: [
      "Limpieza completa + cambio de pasta térmica",
      "Limpieza de cooler",
      "Mantenimiento preventivo y limpieza de Joystick"
    ]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Rapidez",
    description: "Diagnósticos precisos y reparaciones eficientes. Tu equipo listo en el menor tiempo posible.",
    icon: "⚡"
  },
  {
    id: 2,
    title: "Calidad",
    description: "Componentes originales, herramientas profesionales y garantía en todos nuestros trabajos.",
    icon: "🏆"
  },
  {
    id: 3,
    title: "Trato personalizado",
    description: "Atención dedicada y asesoramiento técnico adaptado a las necesidades específicas de cada cliente.",
    icon: "👥"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Tomas Guagnini",
    location: "Lincoln, Buenos Aires",
    avatar: "TG",
    rating: 5,
    comment: "¡Impecable! Solucionó al toque, cero drama.",
    type: "Local Guide"
  },
  {
    id: 2,
    name: "Francisco Lavoz",
    location: "La Plata",
    avatar: "FL",
    rating: 5,
    comment: "Soy de La Plata y me solucionó problemas de Windows, drivers y programas. 10/10.",
    type: "Local Guide"
  },
  {
    id: 3,
    name: "Francisco Lerena Herrera",
    location: "Lincoln, Buenos Aires",
    avatar: "FL",
    rating: 5,
    comment: "Servicio muy rápido y eficiente. Me explicó todo muy bien.",
    type: "2 reviews"
  },
  {
    id: 4,
    name: "Gian Lucas Di Leo",
    location: "Buenos Aires",
    avatar: "GL",
    rating: 5,
    comment: "De 10, estuve meses queriendo arreglar mi notebook y ellos fueron los únicos que me lo resolvieron. Muy profesionales.",
    type: ""
  },
  {
    id: 5,
    name: "Tomás Vinella",
    location: "Buenos Aires",
    avatar: "TV",
    rating: 5,
    comment: "Vino hasta mi domicilio y, en un rato, me limpió todos los componentes y me cambió la pasta térmica. Un lujo, y la atención diez puntos.",
    type: "Local Guide"
  },
  {
    id: 6,
    name: "Facundo Arce",
    location: "Buenos Aires",
    avatar: "FA",
    rating: 5,
    comment: "¡Muy buena predisposición y excelente trabajo!",
    type: "1 review"
  },
  {
    id: 7,
    name: "Nico Sesarego",
    location: "Buenos Aires",
    avatar: "NS",
    rating: 5,
    comment: "Increíblemente rápido, detallista y eficaz. Resolvió todos los problemas de mi PC que otros técnicos no pudieron. 10/10.",
    type: ""
  },
  {
    id: 8,
    name: "Aristides Oberti",
    location: "Buenos Aires",
    avatar: "AO",
    rating: 5,
    comment: "Excelente atención, me dejó el celu y la compu como nueva; súper recomendable.",
    type: ""
  }
];

export const plans = [
  {
    id: 1,
    name: "Plan Básico",
    price: 13800,
    frequency: "Trimestral",
    icon: "💼",
    description: "Ideal para prevenir fallas y mantener equipos en buen estado.",
    features: [
      "Limpieza interna y externa de PCs y notebooks",
      "Revisión física y cambio de pasta térmica anual",
      "Actualizaciones de software y parches",
      "Informe de estado general de cada equipo"
    ],
    discounts: {
      "5 equipos": "5%",
      "10 equipos": "10%",
      "20+ equipos": "20%"
    },
    popular: false
  },
  {
    id: 2,
    name: "Rendimiento Óptimo",
    price: 37600,
    frequency: "Bimestral",
    icon: "⚡",
    description: "Perfecto para uso diario y máximo rendimiento.",
    features: [
      "Todo lo del Plan Prevención Esencial",
      "Optimización de sistema operativo",
      "Mantenimiento preventivo de impresoras",
      "Reemplazo de piezas menores sin costo",
      "Respaldo básico de información"
    ],
    discounts: {
      "5 equipos": "5%",
      "10 equipos": "10%",
      "20+ equipos": "20%"
    },
    popular: true
  },
  {
    id: 3,
    name: "Soporte Total",
    price: 95800,
    frequency: "Mensual + Asistencia Remota",
    icon: "🚀",
    description: "Para empresas que necesitan prioridad y mínima interrupción.",
    features: [
      "Todo lo del Plan Rendimiento Óptimo",
      "Asistencia remota (3 intervenciones/mes)",
      "Respuesta prioritaria en menos de 24 h.",
      "Monitoreo preventivo continuo"
    ],
    discounts: {
      "5 equipos": "5%",
      "10 equipos": "10%",
      "20+ equipos": "20%"
    },
    popular: false
  }
];

export const contactInfo = {
  address: "Vicente López 1029",
  city: "Lincoln, Buenos Aires, Argentina",
  email: "contacto@rgserviciotecnico.com",
  phone: "2355-544386",
  whatsapp: "5492355544386",
  instagram: "@rgserviciotec",
  hours: "Solo con cita previa. Contáctanos para coordinar."
};
